import { Modal } from "react-bootstrap";
import useTranslator from "../../../hooks/useTranslator";

const RequestAcceptingModal = ({ show, onClose, acceptedGuaranteeName }) => {
  const { _t } = useTranslator();
  return (
    <Modal
      show={show}
      centered
      className="wrapper-modal newmodalui asguarantor modal-lg pending-request-modal"
    >
      <Modal.Header closeButton onHide={onClose}></Modal.Header>

      <Modal.Body>
        <div className="accept-modal-info">
          <div className="accept-icon">
            <svg
              width="16"
              height="14"
              viewBox="0 0 16 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16 1.26174L5.02857 12L0 7.0783L1.28914 5.81656L5.02857 9.46756L14.7109 0L16 1.26174Z"
                fill="#253837"
              />
            </svg>
          </div>
          <h3>{_t("youAreNowLinkedAsAGuarantor")}</h3>
          <p>
            {_t("yourProfileHasBeenLinkedTo")} {acceptedGuaranteeName}{" "}
            {_t("RentalApplicationYouCanAccessYourSkorProfileAtAnyTime")}
          </p>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default RequestAcceptingModal;
